/**
 * Progressive low-res → high-res loader for collection / category cards.
 * Runs once; each image reaches loaded-highres and never re-enters.
 */
(function () {
  var SELECTOR = '.collection-card-progressive, .featured-category-card-progressive';

  function upgradeImage(img) {
    if (img.dataset.progressiveDone === 'true' || img.dataset.progressiveLoading === 'true') {
      return;
    }

    var lowRes = img.getAttribute('data-lowres');
    var highRes = img.getAttribute('data-highres');
    if (!lowRes) {
      return;
    }

    img.dataset.progressiveLoading = 'true';
    var picture = img.parentElement;
    var webpSource = picture && picture.querySelector('source[type="image/webp"]');

    function markDone() {
      img.dataset.progressiveDone = 'true';
      img.dataset.progressiveLoading = '';
      img.classList.remove('loading', 'loaded-lowres');
      img.classList.add('loaded-highres');
    }

    function applyHighRes() {
      if (!highRes || img.dataset.progressiveDone === 'true') {
        markDone();
        return;
      }

      var preloader = new Image();
      preloader.onload = function () {
        img.addEventListener(
          'load',
          function () {
            markDone();
            if (webpSource && webpSource.dataset.srcset) {
              webpSource.srcset = webpSource.dataset.srcset;
            }
          },
          { once: true }
        );
        img.src = highRes;
      };
      preloader.onerror = markDone;
      preloader.src = highRes;
    }

    function onLowResReady() {
      if (img.dataset.progressiveDone === 'true') {
        return;
      }
      img.classList.remove('loading');
      img.classList.add('loaded-lowres');
      applyHighRes();
    }

    img.classList.add('loading');

    if (img.src === lowRes && img.complete && img.naturalWidth > 0) {
      onLowResReady();
      return;
    }

    img.addEventListener('load', onLowResReady, { once: true });
    img.src = lowRes;
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(upgradeImage);
  }

  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll, { once: true });
  }
})();
